/**
 * @generated SignedSource<<8af537cd2eb9c0f8aa6220fdde7feb4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LessonTypeFilterOption_lessonType$data = {
  readonly description: string | null | undefined;
  readonly id: string;
  readonly index: number;
  readonly name: string;
  readonly visibleToMembers: boolean | null | undefined;
  readonly " $fragmentType": "LessonTypeFilterOption_lessonType";
};
export type LessonTypeFilterOption_lessonType$key = {
  readonly " $data"?: LessonTypeFilterOption_lessonType$data;
  readonly " $fragmentSpreads": FragmentRefs<"LessonTypeFilterOption_lessonType">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LessonTypeFilterOption_lessonType",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "index",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibleToMembers",
      "storageKey": null
    }
  ],
  "type": "LessonType",
  "abstractKey": null
};

(node as any).hash = "aa081e3f170f6ba7220036f2fc0e1d99";

export default node;
